import { createTheme } from '@mui/material/styles';
import  variable from './variable.scss';


export const lightTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: variable.colorPrimary,
      },
      secondary: {
        main: variable.colorSecondary,
      }, 
      background: {
        default: variable.bodyBg,
        paper: variable.colorWhite || '#fff',
      },
      text: {
        primary: variable.colorGrey700 || '#495057',
        secondary: variable.colorSecondary,
      },
    },
  });
  
   